import React, { useEffect, useRef } from "react";
import { Button, Col, Form } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { useErrorContext } from "../contexts/ErrorContext";
import { useLoginContext } from "../contexts/LoginContext";
import { useRegisterContext } from "../contexts/RegisterContext";
import "../css/formulario.css";
import { Get } from "../Utils/Helpers";
import { FetchResponse } from "../Utils/Types";

const LoginForm = () => {
	const { cuil, setCuil, cuilValido, pass, setPass, passHashed, registrado, Login } = useLoginContext();
	const { setRegistrandose } = useRegisterContext();
	const { setErrorMsg } = useErrorContext();

	const refCuil = useRef<NumberFormat>(null);
	const refPass = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (cuil && cuil.replaceAll("_", "").length === 13) {
			refPass.current?.focus();
		}
	}, [cuil]);

	const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();

		const result: FetchResponse = await Get(`/${cuil}/${passHashed}`);

		if (result.error) {
			setErrorMsg(result.ErrorMsg);
			return;
		}

		Login(result);
	};

	useEffect(() => {
		if (cuil && cuil.replaceAll("_", "").length === 13) {
			refPass.current?.focus();
		}
	}, [cuil]);

	const handleCuilOnChange = (v: React.ChangeEvent<HTMLInputElement>) => {
		setCuil(v.target.value);
	};

	const handlePassOnChange = (v: React.ChangeEvent<HTMLInputElement>) => {
		setPass(v.target.value);
	};

	return (
		<Col className='formulario-contenedor'>
			<div className='formulario'>
				<Form>
					<Form.Group className='mb-3' controlId='formBasicEmail'>
						<Form.Label>CUIL</Form.Label>
						<NumberFormat
							format='##-########-#'
							mask='_'
							className='form-control email-input'
							placeholder='Ingrese su CUIL'
							value={cuil}
							onChange={handleCuilOnChange}
							allowEmptyFormatting
							autoFocus
							ref={refCuil}
						/>
					</Form.Group>

					<Form.Group className='mb-3' controlId='formBasicPassword'>
						<Form.Label>Contraseña</Form.Label>
						<Form.Control
							type='password'
							placeholder='Contraseña'
							className='clave-input'
							value={pass}
							onChange={handlePassOnChange}
							ref={refPass}
						/>
					</Form.Group>
					<Button
						variant='primary'
						type='submit'
						size='lg'
						onClick={handleSubmit}
						disabled={!cuilValido || pass.length < 4 || !registrado}
					>
						Iniciar Sesión
					</Button>
					<Button
						variant='link'
						className='btn-registrarse'
						onClick={(e) => {
							e.preventDefault();
							setRegistrandose(true);
						}}
					>
						Registrarse
					</Button>
				</Form>
			</div>
		</Col>
	);
};

export default LoginForm;
